export default __webpack_public_path__ + "static/media/icon-youtube.11369727.svg";